<template>
  <div class="art-calendar">
    <div class="art-calendar-header">
      <slot name="header">
        <b>{{ month }}</b>
        <div>
          <el-button
            size="mini"
            icon="el-icon-arrow-left"
            class="art-calendar-pre"
            @click="preMonth"
            >上个月</el-button
          >
          <el-button
            size="mini"
            icon="el-icon-date"
            class="art-calendar-current"
            @click="toCurrent"
            >今天</el-button
          >
          <el-button
            size="mini"
            icon="el-icon-arrow-right"
            class="art-calendar-next"
            @click="nextMonth"
            >下个月</el-button
          >
        </div>
      </slot>
    </div>
    <div class="art-calendar-week">
      <div class="week-item" v-for="weekNo in weeks" :key="weekNo">
        {{ weekNo }}
      </div>
    </div>
    <div class="art-calendar-date art-calendar-border">
      <div class="art-calendar-row" v-for="(cols, key) in dates" :key="key">
        <div
          class="date-item"
          v-for="col in cols"
          :key="col"
          :class="getClass(col)"
          @click="checkDate(col)"
        >
          <slot name="dateCell" :date="col">
            <div class="date-content" >
              <span :class="date == col?'current':''">{{ col.slice(-2) }}</span> 
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: {
      type: String,
      default: () => {
        return moment().format("YYYY-MM-DD");
      },
    },
  },
  data() {
    return {
      date: this.value,
      weeks: ["一", "二", "三", "四", "五", "六", "日"],
    };
  },
  watch: {
    value() {
      this.date = this.value;
    },
    month() {
      let data = {
        month: this.month,
        start: this.start.format("YYYY-MM-DD"),
        end: this.end.format("YYYY-MM-DD"),
      };
      this.$emit("monthChange", data);
    },
  },
  computed: {
    month() {
      return moment(this.date).format("YYYY-MM");
    },
    start() {
      let monthStart = moment(this.month + "-01");
      let weekNo = monthStart.day() || 7;
      return monthStart.subtract(weekNo - 1, "days");
    },
    end() {
      let monthEnd = moment(this.month).endOf("month");
      let weekNo = monthEnd.day() || 7;
      return monthEnd.add(7 - weekNo, "days");
    },
    dates() {
      let arr = [];
      let start = this.start.format("YYYY-MM-DD");
      let end = this.end.format("YYYY-MM-DD");
      do {
        arr.push(start);
        start = this.start.add(1, "days").format("YYYY-MM-DD");
      } while (start <= end);
      let rows = {};
      for (let index = 0; index < arr.length / 7; index++) {
        rows["week" + index] = [];
        rows["week" + index].push(arr[index * 7]);
        rows["week" + index].push(arr[index * 7 + 1]);
        rows["week" + index].push(arr[index * 7 + 2]);
        rows["week" + index].push(arr[index * 7 + 3]);
        rows["week" + index].push(arr[index * 7 + 4]);
        rows["week" + index].push(arr[index * 7 + 5]);
        rows["week" + index].push(arr[index * 7 + 6]);
      }
      return rows;
    },
  },
  methods: {
    checkDate(date) {
      this.date = date;
      this.$emit("input", this.date);
    },
    preMonth() {
      this.date = moment(this.month + "-01")
        .subtract(1, "months")
        .format("YYYY-MM-DD");
      this.$emit("input", this.date);
    },
    toCurrent() {
      this.date = moment().format("YYYY-MM-DD");
      this.$emit("input", this.date);
    },
    nextMonth() {
      this.date = moment(this.month + "-01")
        .add(1, "months")
        .format("YYYY-MM-DD");
      this.$emit("input", this.date);
    },
    getClass(date) {
      if (date.indexOf(this.month) < 0) {
        return "other-month";
      }
      if (date == this.date) {
        return "date-check";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
